import { Modal } from "react-bootstrap";
import {
    Input,
    TextArea,
    Select,
    InputImagePremium,
} from "../../../Layout/Forms/Form";
import SerializaeHours from "./HoursList";
import "../../Campaigns/Campaigns.css";
import "./_FormTable.css"; // Ensure access to glass styles

const EventHeaderEditModal = ({
    show,
    onHide,
    state,
    handleChangeInputs,
    handlerChangeImage,
    handlerSubmitFormEvent,
    seriaizeVenues
}) => {

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            contentClassName="glass-modal" // Using the same glass style as other modals
            backdrop="static"
        >
            <Modal.Header className="border-0 d-flex align-items-center">
                <Modal.Title className="text-white fw-bold">
                    <i className="fa-solid fa-pen-to-square me-2 text-primary"></i>
                    Editar Detalhes do Evento
                </Modal.Title>
                <button
                    type="button"
                    className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center ms-auto border-0 bg-white bg-opacity-10 hover-scale"
                    onClick={onHide}
                    style={{
                        width: '36px',
                        height: '36px',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <i className="fa-solid fa-xmark text-white fs-5"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="p-4">
                <div className="row g-4">
                    {/* Image Section */}
                    <div className="col-12 col-md-4">
                        <div style={{ height: '350px' }}>
                            <InputImagePremium
                                label="Imagem do Evento"
                                name="event_image"
                                value={state.form.event_image_url}
                                onChange={handlerChangeImage}
                                errors={state.errors}
                            />
                        </div>
                    </div>

                    {/* Form Fields */}
                    <div className="col-12 col-md-8">
                        <div className="row g-3">
                            <div className="col-12">
                                <Input
                                    label="Nome do Evento"
                                    name="name"
                                    placeholder="Título do evento..."
                                    value={state.form.name}
                                    onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                                    onChange={handleChangeInputs}
                                    className="form-control glass-input fs-5 fw-bold"
                                    errors={state.errors}
                                />
                            </div>
                            {/* <div className="col-12">
                                <Select
                                    label="Estabelecimento"
                                    name="id_venues"
                                    value={state.form.id_venues}
                                    onChangeOption={handleChangeInputs}
                                    options={seriaizeVenues()}
                                    className="form-select glass-input"
                                    errors={state.errors}
                                />
                            </div> */}

                            {/* Date & Time */}
                            <div className="col-12">
                                <label className="form-label text-white-50 small text-uppercase fw-bold ls-1 mb-2">Horário</label>
                                <div className="row g-2">
                                    <div className="col-6">
                                        <Input
                                            label="Data Início"
                                            name="date"
                                            value={state.form.date}
                                            onChange={handleChangeInputs}
                                            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                                            type="date"
                                            className="form-control glass-input"
                                            errors={state.errors}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Select
                                            label="Hora Início"
                                            name="hour_start"
                                            value={state.form.hour_start}
                                            onChangeOption={handleChangeInputs}
                                            options={SerializaeHours}
                                            className="form-select glass-input"
                                            errors={state.errors}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Input
                                            label="Data Fim"
                                            name="date_end"
                                            value={state.form.date_end}
                                            onChange={handleChangeInputs}
                                            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                                            type="date"
                                            className="form-control glass-input"
                                            errors={state.errors}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <Select
                                            label="Hora Fim"
                                            name="hour_end"
                                            value={state.form.hour_end}
                                            onChangeOption={handleChangeInputs}
                                            options={SerializaeHours}
                                            className="form-select glass-input"
                                            errors={state.errors}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Description */}
                    <div className="col-12">
                        <TextArea
                            label="Breve Descrição"
                            name="description"
                            placeholder="O que vai acontecer..."
                            value={state.form.description}
                            onChange={handleChangeInputs}
                            onPaste={(e) => { e.preventDefault(); handleChangeInputs({ target: { name: e.target.name, value: e.clipboardData.getData('Text') } }) }}
                            className="form-control glass-input"
                            errors={state.errors}
                            rows={3}
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-top border-white border-opacity-10 py-3">
                <button className="btn btn-link text-white-50 text-decoration-none me-auto" onClick={onHide}>
                    Cancelar
                </button>
                <button
                    className="btn-action-primary px-4 py-2 rounded-3 fw-bold shadow-lg border-0 d-flex align-items-center gap-2"
                    onClick={() => {
                        handlerSubmitFormEvent();
                        onHide();
                    }}
                >
                    <i className="fa-solid fa-floppy-disk"></i>
                    Guardar Alterações
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EventHeaderEditModal;
